// IndexedDB-backed draft read/write. Keyed by folder signature (spec §5.6).
// Drafts are written on Quit (spec §9) and resurrected on the next Load of
// the same folder.

import { del, get, set } from 'idb-keyval';
import type { Draft } from '../types';

const KEY_PREFIX = 'pose-annotator:draft:';

function key(folderSig: string): string {
  return `${KEY_PREFIX}${folderSig}`;
}

export async function readDraft(folderSig: string): Promise<Draft | null> {
  const v = await get<Draft | undefined>(key(folderSig));
  return v ?? null;
}

export async function writeDraft(folderSig: string, draft: Draft): Promise<void> {
  await set(key(folderSig), draft);
}

export async function deleteDraft(folderSig: string): Promise<void> {
  await del(key(folderSig));
}
